import { add, isAfter } from "date-fns";

import { localStorageFacade } from "@services/LocalStorageFacade";

import { UseStorageExpirationDateReturn } from "./useStorageExpirationDate.types";

export const useStorageExpirationDate = (
  key: string,
): UseStorageExpirationDateReturn => {
  const expKey = `EXP_${key}`;
  const localStorage = localStorageFacade();

  const expirationDate: UseStorageExpirationDateReturn["expirationDate"] =
    (() => {
      const item = localStorage.getItem(expKey);

      return item ? new Date(item) : null;
    })();

  const isExpired: UseStorageExpirationDateReturn["isExpired"] = expirationDate
    ? isAfter(new Date(), expirationDate)
    : true;

  const setExpirationDate: UseStorageExpirationDateReturn["setExpirationDate"] =
    date => localStorage.setItem(expKey, String(date));

  const generateExpirationDate: UseStorageExpirationDateReturn["generateExpirationDate"] =
    (daysSpan, date = new Date()) => add(date, { days: daysSpan });

  return {
    isExpired,
    expirationDate,
    setExpirationDate,
    generateExpirationDate,
  };
};
